import React from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';

export default class MapContacts extends React.Component {
  constructor() {
    super();

    this.state = { template: null };

    this.createTemplateLayoutFactory = ymaps => {
      if (ymaps && !this.state.template) {
        this.setState({
          template: ymaps.templateLayoutFactory.createClass(
            '<h3>Мы находимся тут</h3>'
          ),
        });
      }
    };
  }

  render() {
   return (
    <div className='yandex-map'>
      <YMaps>
        <Map
          modules={['control.ZoomControl', 'control.FullscreenControl', 'templateLayoutFactory']}
          state={{
            center: [57.582844, 39.907591],
            zoom: 18,
            controls: ['zoomControl', 'fullscreenControl'],
          }}
           width={'100%'}
          height={400}
        >
          <Placemark
            defaultGeometry={[57.582844, 39.907591]}
            modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
            options={{
              balloonContentLayout: this.state.template,
              iconColor: 'red'
            }}
          />
        </Map>
      </YMaps>
    </div>)
  }
}